export const readFileContent = (file) => {
  if (!file) {
    throw new Error("File is not provided.");
  }
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = () => reject(new Error("File read error: Unknown error"));
    reader.readAsText(file);
  });
};
